<template>
  <div>
    <b-modal
        hide-footer
        id="modal-ftFile"
        centered
        size="lg"
        title="Dateien"
        no-close-on-backdrop
    >
      <b-row>
        <b-col
            md="12"
            xl="12"
        >
          <b-form-group
              label=""
          >
            <b-form-file
                v-model="SelectedFile"
                placeholder="Datei auswählen"
                drop-placeholder="Datei herreinziehen"
            />
          </b-form-group>

          <b-form-group
              label="Tags"
          >
            <b-form-tags
                v-model="Tags"
                input-id="tags-separators"
                separator=" ,;"
                placeholder=""
                no-add-on-enter
                class="mb-2"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-button class="float-right btn-block" variant="success" @click="uploadFile">
          Hochladen
          <div
              v-show="Loading"
              class="spinner-border spinner-border-sm"
              role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </b-button>
      </b-row>
      <template #modal-footer="{ ok, cancel}">

      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BBadge, BDropdown, BButton, BFormInput, BPagination, BFormSelect, BCol, BFormGroup, BInputGroupAppend, BInputGroup, BRow, BTable, BAlert, BFormCheckbox, BFormFile, BFormTags
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import BCardCode from '@core/components/b-card-code'

export default {
  components: {
    BCardCode,
    BButton,
    BRow,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormFile,
    BFormTags
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      SelectedFile: null,
      TargetTyp: 0,
      TargetId: 0,
      Tags: [],
      Loading: false
    }
  },
  mounted() {
    this.Reset();
  },
  methods: {
    Reset() {
      this.Loading = false;
      this.SelectedFile = null
      this.TargetTyp = 0
      this.TargetId = 0
      this.Tags = []

    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          },
      )}`
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0]
    },
    uploadFile() {
      if (this.SelectedFile) {
        if(this.Loading == true)
          return

        this.Loading = true;

        const formData = new FormData()
        formData.append('file', this.SelectedFile)
        formData.append('targetId', this.TargetId)
        formData.append('tags', this.Tags)
        formData.append('targetType', this.TargetTyp)
        this.$http.post('/files/upload', formData)
            .then(resp => {
              if (resp.data.success) {
                this.$swal({
                  icon: 'success',
                  title: 'Erfolgreich!',
                  text: 'Datei wurde hochgeladen.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(result => {
                  if (result.value) {
                    this.Reset();
                  }
                });
              }
            })
            .catch(err => {
              console.error(err)
            })
      }
    },
    OpenMenu(targetTyp, targetId) {
      this.Reset()
      this.TargetId = targetId
      this.TargetTyp = targetTyp
      console.log(this.TargetId)
      console.log(this.TargetTyp)
      this.$bvModal.show('modal-ftFile')
    },
    CloseMenu() {
      this.$bvModal.hide('modal-ftFile')
    },
  },
}
</script>

<style scoped>

</style>